module.exports = __webpack_public_path__ + "static/media/Trinidad Dr, Tiburon, CA4.367f5457.jpg";